import React from 'react';
import { Container } from '@material-ui/core';
import { Banner } from '@/components/uikit';

interface Props {
  children: React.ReactNode;
}

const AltLayout = ({ children }: Props) => (
  <>
    <Banner type="app-install" right={16} />
    <Container maxWidth="sm" className="container-alt">
      <>{children}</>
    </Container>
  </>
);

export default AltLayout;
